import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { getGameStatus } from '../gameSlice';
import useDisableBrowserBack from "../../hooks/useDisableBrowserBack";
import useReadCookies from "../../hooks/useReadCookies";
import Help from "../shared/help";
import Timer from "../shared/timer";
import ImageViewer from "./imageViewer";
import MainQuestion from "./mainQuestion";
import MainQuestionEnd from "./mainQuestionEnd";
import Mission from "./mission";
import MixNMatch from "./mixNMatch";
import Swipe from "./swipe";
import HelpContent from "../shared/helpContent";

function QuestionOverview()
{
  useDisableBrowserBack();
  const dispatch = useDispatch();

  const [showMainQuestion, setShowMainQuestion] = useState(false);
  const [showMixNMatch, setShowMixNMatch] = useState(false);
  const [showSwipe, setShowSwipe] = useState(false);
  const [showMainQuestionEnd, setShowMainQuestionEnd] = useState(false);
  const [showSubGameTip, setShowSubGameTip] = useState(false);
  const [showImageViewer, setShowImageViewer] = useState(false);
  const [showMissionOnly, setShowMissionOnly] = useState(false);
  const [isMissionEnd, setIsMissionEnd] = useState(false);
  const [isMissionSuccess, setIsMissionSuccess] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [currentPage, setCurrentPage] = useState("question_overview");

  const missions = useSelector((state) => state.game.missions);
  const currentMission = useSelector((state) => state.game.currentMission);
  const currentMissionData = useSelector((state) => state.game.missions[currentMission]);

  let { cookiePlayerId, cookieGroupId } = useReadCookies();

  useEffect(()=> {
    dispatch(getGameStatus(cookieGroupId));

    // polling for group status every 5 seconds until group is confirmed  
    const interval = setInterval(() => {
      dispatch(getGameStatus(cookieGroupId));
    } , 5000);  

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if(currentMissionData && cookiePlayerId === currentMissionData.main_question_player && currentMissionData.finished){
      if(currentMissionData && currentMissionData.mission_passed){
        setIsMissionSuccess(true);
      }
      if(!isMissionEnd){
        setShowMainQuestionEnd(false);
        setShowMissionOnly(false);
      }
      setIsMissionEnd(true);
      
    }

    if(currentMissionData && cookiePlayerId === currentMissionData.mix_n_match_player && currentMissionData.finished){
      if(currentMissionData && currentMissionData.mission_passed){
        setIsMissionSuccess(true);
      }
      setIsMissionEnd(true);
      setShowMissionOnly(false);
      //setShowSubGameTip(false);
    }

    if(currentMissionData && cookiePlayerId === currentMissionData.swipe_player && currentMissionData.finished){
      if(currentMissionData && currentMissionData.mission_passed){
        setIsMissionSuccess(true);
      }
      setIsMissionEnd(true);
      setShowMissionOnly(false);
      //setShowSubGameTip(false);
    }
  }, [missions, currentMission, currentMissionData]);

  const handleShowQuestion = (currentMissionData) => {
    if(cookiePlayerId === currentMissionData.main_question_player){
      if(currentMissionData.finished){
        setShowMainQuestion(false);
      }else {
        setShowMainQuestion(true);
        setCurrentPage("main_question");
      }
    }else if(cookiePlayerId === currentMissionData.mix_n_match_player){
      if(currentMissionData.finished){
        setShowMixNMatch(false);
      }else {
        setShowMixNMatch(true);
        setCurrentPage("mix_n_match");
      }
    }else if(cookiePlayerId === currentMissionData.swipe_player && !currentMissionData.finished){
      if(currentMissionData.finished){
        setShowSwipe(false);
      }else {
        setShowSwipe(true);
        setCurrentPage("swipe");
      }
    }
  }

  return (
    <div className="mobileContainer blackNights question-overview-screen">
      <div className="appHeader">
        <Timer tooltip={currentMission === 0 && !missions[currentMission].finished ? true : false} />
        <Help setShowHelp={setShowHelp} />
      </div>
      <Mission 
        lift={showMainQuestion} 
        missionOnly={showMissionOnly} 
        missionEnd={isMissionEnd} 
        missionSuccess={isMissionSuccess} 
        showQuestion={handleShowQuestion}
        miniGameActive={showMixNMatch || showSwipe ? true : false}
      />
      {showMainQuestion && <MainQuestion 
          setShowImageViewer={setShowImageViewer} 
          missionData={currentMissionData}
          isMissionEnd={isMissionEnd}
          setShowMainQuestionEnd={setShowMainQuestionEnd}
          setIsMissionSuccess={setIsMissionSuccess}
          setIsMissionEnd={setIsMissionEnd}
          setShowMissionOnly={setShowMissionOnly}
        />}
      {showMixNMatch && <MixNMatch 
        missionData={currentMissionData} 
        setShowMixNMatch={setShowMixNMatch} 
        setShowSubgameTip={setShowSubGameTip} 
        showSubgameTip={showSubGameTip}
        isMissionEnd={isMissionEnd}/>}
      {showSwipe && <Swipe 
        missionData={currentMissionData} 
        setShowSwipe={setShowSwipe} 
        setShowSubgameTip={setShowSubGameTip} 
        showSubgameTip={showSubGameTip}
        isMissionEnd={isMissionEnd}/>}
      {showMainQuestionEnd && <MainQuestionEnd 
        missionSuccess={isMissionSuccess}
      />}
      {showImageViewer && <ImageViewer setShowImageViewer={setShowImageViewer} missionData={currentMissionData} />}
      {showHelp && <HelpContent setShowHelp={setShowHelp} page={currentPage} />}
    </div>
  )
}


/*
{showMixNMatch && <MixNMatch 
        missionData={currentMissionData} 
        setShowMixNMatch={setShowMixNMatch} 
        setShowSubgameTip={setShowSubGameTip} />}


*/

/* 
{showSubGameTip && <SubGameTip missionData={currentMissionData} setShowSubgameTip={setShowSubGameTip} /> }
*/
export default QuestionOverview;